import { conditions as globalConditions } from './global';
import { hospitalIndemnityConditions, } from './hospitalIndemnity';
import { petInsuranceConditions, } from './petInsurance';
export const hospitalConditions = {
    ...globalConditions,
    ...hospitalIndemnityConditions,
};
export const petConditions = {
    ...globalConditions,
    ...petInsuranceConditions,
};
function isValidHospitalCondition(value) {
    return value in hospitalConditions;
}
function isValidPetCondition(value) {
    return value in petConditions;
}
/**
 * Determine if the condition is true, and the dependent content can trigger
 */
export function validateConditions(content, state) {
    const conditionCode = content.elements.condition.value[0];
    // If there is no condition, then continue with content
    if (!conditionCode) {
        return true;
    }
    if (isValidHospitalCondition(conditionCode)) {
        return hospitalConditions[conditionCode](state);
    }
    else if (isValidPetCondition(conditionCode)) {
        return petConditions[conditionCode](state);
    }
    else {
        throw Error(`Invalid condition code: ${conditionCode}`);
    }
}
//# sourceMappingURL=index.js.map